import { render, staticRenderFns } from "./AudioTrackConsumer.vue?vue&type=template&id=1071ea6b&"
import script from "./AudioTrackConsumer.vue?vue&type=script&lang=js&"
export * from "./AudioTrackConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports